import { TypographyOptions } from '@mui/material/styles/createTypography';

/**
 * Typography used in theme
 */
export default function themeTypography(): TypographyOptions {
    return {
        // 空状态大标题 40/48
        h2: {
            fontSize: '40px',
            lineHeight: '48px',
            fontWeight: 700,
        },
        // 标题 24/32
        h4: {
            fontSize: '24px',
            lineHeight: '32px',
            fontWeight: 500,
        },
        // 标题-加粗 24/32
        h3: {
            fontSize: '24px',
            lineHeight: '32px',
            fontWeight: 700,
        },
        // 正文 20/24
        body1: {
            fontSize: '20px',
            lineHeight: '24px',
            fontWeight: 500,
        },
        // 正文-加粗 20/24
        subtitle1: {
            fontSize: '20px',
            lineHeight: '24px',
            fontWeight: 700,
        },
        // 次要文本 16/24
        body2: {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 500,
        },
        // 次要文本-加粗 16/24
        subtitle2: {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 700,
        },
    }
    // return {
    //     fontFamily: theme.fontFamily,
    //     h6: {
    //         fontWeight: 500,
    //         color: theme.heading,
    //         fontSize: '0.75rem'
    //     },
    //     h5: {
    //         fontSize: '0.875rem',
    //         color: theme.heading,
    //         fontWeight: 500
    //     },
    //     h4: {
    //         fontSize: '1rem',
    //         color: theme.heading,
    //         fontWeight: 600
    //     },
    //     h3: {
    //         fontSize: '1.25rem',
    //         color: theme.heading,
    //         fontWeight: 600
    //     },
    //     h2: {
    //         fontSize: '1.5rem',
    //         color: theme.heading,
    //         fontWeight: 700
    //     },
    //     h1: {
    //         fontSize: '2.125rem',
    //         color: theme.heading,
    //         fontWeight: 700
    //     },
    //     subtitle1: {
    //         fontSize: '0.875rem',
    //         fontWeight: 500,
    //         color: theme.textDark
    //     },
    //     subtitle2: {
    //         fontSize: '0.75rem',
    //         fontWeight: 400,
    //         color: theme.darkTextSecondary
    //     },
    //     caption: {
    //         fontSize: '0.75rem',
    //         color: theme.darkTextSecondary,
    //         fontWeight: 400
    //     },
    //     body1: {
    //         fontSize: '0.875rem',
    //         fontWeight: 400,
    //         lineHeight: '1.334em'
    //     },
    //     body2: {
    //         letterSpacing: '0em',
    //         fontWeight: 400,
    //         lineHeight: '1.5em',
    //         color: theme.darkTextPrimary
    //     },
    //     customInput: {
    //         marginTop: 8,
    //         marginBottom: 8,
    //         '& > label': {
    //             top: '23px',
    //             left: 0,
    //             color: theme.grey500,
    //             '&[data-shrink="false"]': {
    //                 top: '5px'
    //             }
    //         },
    //         '& > div > input': {
    //             padding: '30.5px 14px 11.5px !important'
    //         },
    //         '& legend': {
    //             display: 'none'
    //         },
    //         '& fieldset': {
    //             top: 0
    //         }
    //     },
    //     mainContent: {
    //         backgroundColor: theme.background,
    //         width: '100%',
    //         minHeight: 'calc(100vh - 88px)',
    //         flexGrow: 1,
    //         padding: '20px',
    //         marginTop: '88px',
    //         // marginRight: '20px',
    //         borderRadius: `${theme.borderRadius}px`
    //     },
    //     menuCaption: {
    //         fontSize: '0.875rem',
    //         fontWeight: 500,
    //         color: theme.heading,
    //         padding: '6px',
    //         textTransform: 'capitalize',
    //         marginTop: '10px'
    //     },
    //     subMenuCaption: {
    //         fontSize: '0.6875rem',
    //         fontWeight: 500,
    //         color: theme.darkTextSecondary,
    //         textTransform: 'capitalize'
    //     },
    //     commonAvatar: {
    //         cursor: 'pointer',
    //         borderRadius: '8px'
    //     },
    //     smallAvatar: {
    //         width: '22px',
    //         height: '22px',
    //         fontSize: '1rem'
    //     },
    //     mediumAvatar: {
    //         width: '34px',
    //         height: '34px',
    //         fontSize: '1.2rem'
    //     },
    //     largeAvatar: {
    //         width: '44px',
    //         height: '44px',
    //         fontSize: '1.5rem'
    //     }
    // };
}
